import React, { useRef } from 'react';
import { Helmet } from "react-helmet";
import { AnimatePresence, motion } from 'framer-motion';
import { LocomotiveScrollProvider } from 'react-locomotive-scroll';
import 'locomotive-scroll/src/locomotive-scroll.scss';

// Components
import Header from '../../components/header';
import Footer from '../../components/footer';
import NewsList from './views/newsList';
import Accordion from '../../components/accordion';
import TagsList from '../../components/tagsList/tagsList';

// Utils
import { MoveWhenVisible } from '../../utils/moveWhenVisible';

//Hooks
import useNewsPage from '../../hooks/ui/useNewsPage';
import useHandleTags from "../../hooks/utils/useHandleTags";
import useWindowSize from '../../hooks/utils/useWindowSize';
import useNewsMeta from "../../hooks/ui/useNewsMeta";

function NewNews() {
    const { title, tagsList, newsList } = useNewsPage();
    const { oggTitle, oggImage, oggDescription } = useNewsMeta();
    
    const containerRef = useRef(null);
    const { activeChips, handleChips } = useHandleTags();
    const { width } = useWindowSize();

    const isMobile = width <= 480;

    const filteredNews = activeChips.length
        ? newsList.filter((user) =>
              user.fields.tagsList.length === activeChips.length
                  ? user.fields.tagsList.every((tag) =>
                        activeChips.map((chip) => chip).includes(tag.fields.title)
                    )
                  : activeChips
                        .map((chip) => chip)
                        .every((chip) =>
                            user.fields.tagsList.map((t) => t.fields.title).includes(chip)
                        )
          )
        : newsList;

    return (
        <LocomotiveScrollProvider
            options={{
                smooth: true,
                scrollFromAnywhere: true,
                multiplier: 0.75,
                lerp: 0.03,
                tablet: { smooth: true, multiplier: 0.55 },
                smartphone: { smooth: false }
            }}
            watch={[]}
            containerRef={containerRef}>
            <Helmet>
              <title>{oggTitle}</title>
              <meta property="og:title" content={oggTitle} />
              <meta property="og:description" content={oggDescription} />
              <meta property="og:image" content={oggImage.url} />
            </Helmet>
            <div className={'page new-news'} data-scroll-container ref={containerRef}>
                <Header />

                <div className={'page_view'} data-scroll-section>
                    <div className={'new-news_view'}>
                        <MoveWhenVisible fromX={0} toX={20} delayFrom={0.2} delayTo={0.2}>
                            <h1 className={'page_title new-news_title'}>{title}</h1>
                        </MoveWhenVisible>
                    </div>
                    
                    <Accordion isMobile={isMobile}>
                        <TagsList classNames={'new-news-tips'} tagsList={tagsList} employeesListSection={newsList} activeChips={activeChips} handleChips={handleChips} />
                    </Accordion>

                    <div className={'new-news-result'}>
                        {tagsList.length ? (
                            <AnimatePresence>
                                {!filteredNews.length ? (
                                    <motion.div
                                        className={'no-matches'}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}>
                                        No matches found, please limit your selections.
                                    </motion.div>
                                ) : (
                                    ''
                                )}
                            </AnimatePresence>
                        ) : null}

                        <NewsList activeChips={activeChips} filteredNews={filteredNews} />
                    </div>
                </div>

                <Footer />
            </div>
        </LocomotiveScrollProvider>
    );
}

export default NewNews;
